interface HeroCarouselSurfaceConfig {
  palette?: App.Design.PaletteType
  carouselPalette?: App.Design.PaletteType
  background?: unknown
  videoSourceUrl?: string
  // Present on real configs but must not trip the custom-surface gate by themselves.
  campaignId?: string
  title?: unknown
  logo?: unknown
}

export type ExclusiveOfferCarouselTileStyle = 'card-opaque' | 'card-default'

export interface ExclusiveOfferCarouselSurface {
  isRebrandExclusiveSurface: boolean
  containerPalette: App.Design.PaletteType
  titleSheetPalette: App.Design.PaletteType
  carouselSheetPalette: App.Design.PaletteType
  tileStyle: ExclusiveOfferCarouselTileStyle
  useOpaqueCarousel: boolean
}

/**
 * True when a site takeover or hero carousel config owns the surface
 * (palette / background / video). Those cases must not get the default
 * exclusive-carousel rebrand teal treatment.
 */
export function hasCustomHeroOfferCarouselSurface({
  siteTakeoverTheme,
  heroCarouselConfig,
}: {
  siteTakeoverTheme?: unknown
  heroCarouselConfig?: HeroCarouselSurfaceConfig | null
}): boolean {
  return !!(
    siteTakeoverTheme
    || heroCarouselConfig?.palette
    || heroCarouselConfig?.carouselPalette
    || heroCarouselConfig?.background
    || heroCarouselConfig?.videoSourceUrl
  )
}

/**
 * Structural exclusive-carousel surface for rebrand teal vs legacy inverse.
 * Keep body.app-palette-rebrand CSS dual-gated with `.rebrand-highlight` separately.
 */
export function getExclusiveOfferCarouselSurface({
  isRebrand,
  hasCustomHeroSurface = false,
  palette = 'inverse',
  carouselPalette,
}: {
  isRebrand: boolean
  hasCustomHeroSurface?: boolean
  palette?: App.Design.PaletteType
  carouselPalette?: App.Design.PaletteType
}): ExclusiveOfferCarouselSurface {
  const isRebrandExclusiveSurface = isRebrand && !hasCustomHeroSurface
  const useOpaqueCarousel = !!carouselPalette || isRebrandExclusiveSurface

  return {
    isRebrandExclusiveSurface,
    containerPalette: isRebrandExclusiveSurface ? 'default' : palette,
    titleSheetPalette: isRebrandExclusiveSurface ? 'inverse' : palette,
    carouselSheetPalette: useOpaqueCarousel ? 'default' : 'inverse',
    tileStyle: useOpaqueCarousel ? 'card-opaque' : 'card-default',
    useOpaqueCarousel,
  }
}
